

















































import {
	defineComponent,
	PropType,
	ref,
	watch,
} from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import UserAvatar from '@front-app/components/user/avatar.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import { getMemberInvitationDates } from '@front-app/services/GroupsApi/GroupsMemberApi';
import { GroupMember, GroupMemberWithEmail, UserRole } from '@front-app/services/UserApi/UserModel';
import { isExternalMember } from '@front-app/util/user';
import { Size } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useGroupMemberName } from '@front-app/hooks/useTranslate';
import { UserAvatarStore } from '@front-app/store/singletons/User';

export default defineComponent({
	components: {
		ErrorCard,
		LoaderState,
		UserAvatar,
		UserLink,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		selectedMember: {
			type: Object as PropType<GroupMemberWithEmail | GroupMember>,
			required: true,
		},
	},
	setup(props, ctx) {
		const invitationDates = ref([] as Date[]);

		const { track, isLoading, isError } = useAsyncStatus();
		watch(() => props.selectedMember.id, async (newVal, prevVal) => {
			if (newVal !== prevVal) {
				const isTscUser = props.selectedMember.groupRole !== UserRole.EXTERNAL_INVITEE;
				const result = await track(getMemberInvitationDates(props.groupId, props.selectedMember.id, isTscUser));
				invitationDates.value = result;
			}
		}, { immediate: true });

		const getUsername = useGroupMemberName(ctx);

		return {
			isExternalMember,
			getAvatar: UserAvatarStore.get,
			fetchAvatar: UserAvatarStore.fetch,
			getUsername,
			// Invitation dates
			invitationDates,
			isLoading,
			isError,
			// Util
			Size,
		};
	},
});
